import { Pagination, SuccessResponse } from "common/common.interface";
import { environment } from "common/environment";
import { Commande, CreateCommandePayload, DeleteDocumentPayload } from "modules/commande/types/commande.interface";

export interface CommandeBackend {
  getAllCommandes(
    page: number,
    limit: number,
    expired: boolean,
    searchName: string | undefined
  ): Promise<Pagination<Commande>>;
  getCommande(id: string): Promise<Commande>;
  createCommande(
    workspaceId: string,
    payload: CreateCommandePayload
  ): Promise<Commande>;
  updateCommande(id: string, payload: CreateCommandePayload): Promise<Commande>;
  archiveCommande(id: string): Promise<SuccessResponse>;
  uploadDocument(id: string, file: File): Promise<SuccessResponse>;
  deleteDocument(payload: DeleteDocumentPayload): Promise<SuccessResponse>;
}

let commandeBackendInstance: CommandeBackend | undefined;

export async function getCommandeBackend(): Promise<CommandeBackend> {
  if (commandeBackendInstance === undefined) {
    const mod = await import(`./${environment.ARTICLE_BACKEND}`);
    commandeBackendInstance = new mod.default() as CommandeBackend;
  }
  return commandeBackendInstance;
}
